import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "slug-line" }
const _hoisted_2 = { class: "upload-modal-file-list" }
const _hoisted_3 = {
  key: 1,
  class: "upload-progress-list ion-padding-horizontal"
}
const _hoisted_4 = { class: "upload-progress-name" }
const _hoisted_5 = { class: "upload-progress-status" }
const _hoisted_6 = {
  key: 2,
  class: "upload-modal-file-list"
}
const _hoisted_7 = {
  key: 3,
  class: "upload-modal-file-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Каталог музыки",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCreateModal()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.add
                      }, null, 8, ["icon"]),
                      _cache[10] || (_cache[10] = _createTextVNode(" Новая папка ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (f) => {
            return (_openBlock(), _createBlock(_component_ion_card, {
              key: f.id,
              class: "admin-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(f.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("p", _hoisted_1, "/" + _toDisplayString(f.slug) + "/ · " + _toDisplayString(f.accessMode === 'RESTRICTED' ? 'ограничено' : 'всем'), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      size: "small",
                      onClick: ($event: any) => (_ctx.selectFolder(f))
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("Треки и загрузка", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      fill: "outline",
                      onClick: ($event: any) => (_ctx.openEditModal(f))
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Доступ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: "danger",
                      fill: "clear",
                      onClick: ($event: any) => (_ctx.confirmDelete(f))
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Удалить", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showFolderModal,
            onDidDismiss: _ctx.closeFolderModal,
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.folderModalTitle), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeFolderModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, { class: "ion-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.folderModalTitle), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.editTitle,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editTitle) = $event)),
                                label: "Название",
                                "label-placement": "stacked"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode("Доступ", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                modelValue: _ctx.editAccess,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editAccess) = $event)),
                                interface: "popover"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select_option, { value: "PUBLIC" }, {
                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                      _createTextVNode("Все пользователи", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_select_option, { value: "RESTRICTED" }, {
                                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                      _createTextVNode("Только выбранные", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (_ctx.editAccess === 'RESTRICTED')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_ion_searchbar, {
                                  modelValue: _ctx.userSearch,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userSearch) = $event)),
                                  placeholder: "Поиск по логину или имени"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_component_ion_list, { class: "transparent-list" }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (u) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: u.id,
                                          button: "",
                                          onClick: ($event: any) => (_ctx.toggleUserQuick(u.id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, _toDisplayString(u.login), 1),
                                                _createElementVNode("p", null, _toDisplayString(u.firstName) + " " + _toDisplayString(u.lastName), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_note, { slot: "end" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.selectedUserIds.has(u.id) ? '✓' : ''), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_button, {
                            expand: "block",
                            onClick: _ctx.saveFolderModal,
                            disabled: _ctx.saving
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.saving ? 'Сохранение…' : 'Сохранить'), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open", "onDidDismiss"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showTracksModal,
            onDidDismiss: _ctx.closeTracksModal,
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedFolder?.title), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeTracksModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, { class: "ion-padding" }, {
                default: _withCtx(() => [
                  (_ctx.uploadQueue.length)
                    ? (_openBlock(), _createBlock(_component_ion_card, {
                        key: 0,
                        class: "admin-card"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode("Имена на сервере", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "slug-line" }, "Можно менять только имя без расширения; суффикс файла совпадает с исходным.", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadQueue, (q, i) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 'q' + i
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_input, {
                                      modelValue: q.targetName,
                                      "onUpdate:modelValue": ($event: any) => ((q.targetName) = $event),
                                      label: "Сохранить как",
                                      "label-placement": "stacked",
                                      onIonInput: ($event: any) => (_ctx.onUploadTargetNameInput(q, $event))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.flushUpload())),
                                disabled: _ctx.uploadFlushing
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.uploadFlushing ? 'Загрузка…' : 'Загрузить'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                fill: "clear",
                                disabled: _ctx.uploadFlushing,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadQueue = []))
                              }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode("Отмена", -1)
                                ]))]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.uploadProgressList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[20] || (_cache[20] = _createElementVNode("p", { class: "upload-progress-heading" }, "Загрузка файлов", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadProgressList, (p, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'lib-up-' + idx,
                            class: "upload-progress-item"
                          }, [
                            _createElementVNode("p", _hoisted_4, _toDisplayString(p.fileName), 1),
                            _createVNode(_component_ion_progress_bar, {
                              value: p.percent / 100,
                              type: "determinate"
                            }, null, 8, ["value"]),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(p.status), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_card, { class: "admin-card" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            expand: "block",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pickAudio()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.musicalNotesOutline
                              }, null, 8, ["icon"]),
                              _cache[21] || (_cache[21] = _createTextVNode(" Добавить аудио ", -1))
                            ]),
                            _: 1
                          }),
                          _createElementVNode("input", {
                            ref: "fileInput",
                            type: "file",
                            multiple: "",
                            accept: "audio/*",
                            style: {"display":"none"},
                            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFilesPicked && _ctx.onFilesPicked(...args)))
                          }, null, 544)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.tracks.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_ion_list, { class: "transparent-list" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tracks, (t) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: t.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, _toDisplayString(t.name), 1),
                                      _createElementVNode("p", null, _toDisplayString(t.id), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    onClick: ($event: any) => (_ctx.promptRename(t))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "danger",
                                    onClick: ($event: any) => (_ctx.confirmDeleteTrack(t))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("p", { class: "empty-hint ion-padding-horizontal" }, "Нет файлов.", -1)
                      ]))]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open", "onDidDismiss"])
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}